export default () => ({
  legend: {
    layout: 'vertical',
    verticalAlign: 'middle',
    itemMarginTop: 6,
    y: 0,
  },
});
